module.exports = __webpack_public_path__ + "static/media/insect(16).7ba461b8.PNG";